<label class="checkbox-container" [ngClass]="lang" [class.error]="isErrorEnabled" [ngClass]="customClass">
    <span class="title" *ngIf="data.title"
        [innerHtml]="(data?.title?.[lang] ? data?.title?.[lang] : data?.title) | translate | htmlSanitizer"></span>
    <input type="checkbox" [name]="data.name" [(ngModel)]="data.value" (change)="change()" />
    <span class="checkmark"></span>
</label>